import { render } from "./HomePage.vue?vue&type=template&id=35e9afea&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=35e9afea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/website/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e9afea"]])

export default __exports__